import React from 'react';
import { Loader2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';

export default function RemoveAccountDialog({
  open,
  accountName,
  busy = false,
  onOpenChange,
  onConfirm,
}) {
  const name = accountName || 'this account';
  return (
    <AlertDialog open={open} onOpenChange={(next) => !busy && onOpenChange?.(next)}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Remove {name} from your accounts?</AlertDialogTitle>
          <AlertDialogDescription>
            You can add it back any time from Market — its pursuit status and notes are kept.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={busy}>Cancel</AlertDialogCancel>
          <Button type="button" disabled={busy} onClick={() => void onConfirm?.()}>
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Remove'}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
